import type { TFunction } from 'i18next';

import { formatPriceFromCents } from '@mopla/utils';

import { IMyTicket } from './types';

/**
 * Price string shown for a purchased ticket (Home / Tickets cards + detail).
 *
 * A monthly-billed subscription (`recurring_charge_per_period`) renders as
 * "{periodCount} x {monthly price}" — the BE returns the per-month amount in
 * `priceInCents`, and the multiplier communicates the full commitment (MC-11411).
 * Every other ticket (one-time / non-subscription) shows the flat price.
 *
 * `t` must be bound to the `ticketshop` namespace.
 */
export const formatMyTicketPrice = (
	ticket: IMyTicket,
	t: TFunction
): string => {
	if (ticket.priceInCents == null) {
		return '';
	}

	const price = formatPriceFromCents(ticket.priceInCents);

	if (
		ticket.billingMode === 'recurring_charge_per_period' &&
		ticket.periodCount
	) {
		return t('price_monthly', { count: ticket.periodCount, price });
	}

	return price;
};
